import regeneratorRuntime from "regenerator-runtime";
export default class JobEditor {
  constructor(stripeKey, stripeStyle = {}) {
    this.stripeStyle = stripeStyle
    this.stripeKey = stripeKey
    this.checkoutOptions = {
      stripeSecret: null,
      customerName: null
    }
  }

  attachJobEditor(form, stripeField, submit) {
    const paid = form.dataset.mode == 'paid';
     const stripe = Stripe(this.stripeKey);
     const elements = stripe.elements();
     const card = elements.create('card', {
       hidePostalCode: true
     });

    if (paid) {
      // Attach Stripe Elements
      card.mount(stripeField);
    }

    submit.addEventListener('click', async (event) => {
      event.preventDefault();
      await this.submit(form, card, stripe)
    })
  }

  async submit(form, card, stripe) {
    if (this.checkoutOptions.stripeSecret) {
      // We've already successfully created the job posting in Stripe and Kirby
      // The card processing through Stripe elements just failed
      // Try processing payments again instead of posting the payment details again
      return this.payWithStripe(form, card, stripe)
    }
    const data = this.collectedData(form)
    const response = await fetch('/jobs/post', {
      method: 'POST',
      body: JSON.stringify(data)
    })

    const body = await response.json()
    if (!response.ok) {
      if (response.status == 400) {
        this.renderErrors(body.errors)
      } else {
        this.renderErrors(body.errors)
      }
      return
    } else {
      if (body.mode === 'paid') {
        // Successful submission for non-members
        // Now paying with Stripe
        this.checkoutOptions.stripeSecret = body.secret
        await this.payWithStripe(form, card, stripe)
      } else {
        // Success for members
        window.location.pathname = '/dashboard'
      }
    }
  } 

  collectedData(form) {
    let data = {}
    form.querySelectorAll('input,textarea,select').forEach(field => {
      if (field.name && field.name !== "") {
        data[field.name] = field.value
      }
    })
    return data
  }

  renderErrors(errors) {
    // Clear errors 
    document.getElementById('errors').innerHTML = ''

    // Render errors
    const errorList = document.createElement('ul')
    Object.keys(errors).forEach(key => {
      console.log(key)
      const error = Object.keys(errors[key])[0]
      const errorElement = document.createElement('li')
      errorElement.innerText = errors[key][error]
      errorList.appendChild(errorElement)
    })
    document.getElementById('errors').appendChild(errorList)
  }

  async payWithStripe(form, card, stripe) {
    const response = await stripe.confirmCardPayment(this.checkoutOptions.stripeSecret, {
      payment_method: {
        card: card,
        billing_details: {
          name: this.checkoutOptions.customerName,
        },
      }
    })

    if (response.error) {
      this.renderErrors({
        'card': {
          'card': response.error.message
        }
      })
    } else {
      // Success!
      // TODO: @Sean where do we redirect people to one the posting (paid) is complete?
      // The posting isn't live yet so we can't show it really
      window.location.pathname = '/jobs';
    }
  }
}